import React from 'react';
import { CTAMessagingWrapper } from './styled';
import { AULink } from 'components/AULink';

type StickyCTAMessagingProps = {
  content: string;
};

export const StickyCTAMessaging = ({ content }: StickyCTAMessagingProps): JSX.Element => {
  return (
    <CTAMessagingWrapper id="sticky-cta-messaging">
      {content ? (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      ) : (
        <>
          {'Always backed by our '}
          <AULink id="cta-messaging" path="/quality">
            quality guarantee
          </AULink>
        </>
      )}
    </CTAMessagingWrapper>
  );
};
